document.addEventListener("DOMContentLoaded", function () {
  const specialUrls = [
    "https://kennelclubboarding.ca/pages",
    "https://kennelclubboarding.ca/products",
    "https://kennelclubboarding.ca/collections",
    "https://kennelclubboarding.ca/blogs",
    "https://kennelclubboarding.ca/policies",
  ];

  // Function to generate breadcrumb items based on the current URL
  function generateBreadcrumbs() {
    const currentUrl = window.location.href;
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    let breadcrumbItems = [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://kennelclubboarding.ca",
      },
    ];

    // Check if the current URL contains any of the special URLs
    const isSpecialUrl = specialUrls.some((url) => currentUrl.includes(url));

    if (isSpecialUrl) {
      const lastSegment = pathSegments[pathSegments.length - 1];
      breadcrumbItems.push({
        "@type": "ListItem",
        position: 2,
        name: decodeURIComponent(lastSegment.replace(/-/g, " ")),
        item: currentUrl,
      });
    } else {
      pathSegments.forEach((segment, index) => {
        const path = "/" + pathSegments.slice(0, index + 1).join("/");
        breadcrumbItems.push({
          "@type": "ListItem",
          position: index + 2, // Adjust position to account for the Home item
          name: decodeURIComponent(segment.replace(/-/g, " ")),
          item: window.location.origin + path,
        });
      });
    }

    return breadcrumbItems;
  }

  // Main logic to generate and append JSON-LD breadcrumbs
  const breadcrumbItems = generateBreadcrumbs();

  if (breadcrumbItems.length > 0) {
    const jsonLdBreadcrumbs = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbItems,
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLdBreadcrumbs);
    document.head.appendChild(script);
  } else {
    console.warn("No breadcrumb items generated for the current URL.");
  }
});
